import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-email-reminder',
  templateUrl: './email-reminder.component.html',
  styleUrls: ['./email-reminder.component.scss']
})
export class EmailReminderComponent implements OnInit {

  email: any;
  emailSubmitted = false;

  constructor(private coreService: CoreService,
    private authService: AuthService, private router: Router,    public gaService: GaService,
    private toast: ToastrService, private translate: TranslateService, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onSubmit(formRef) {

    const body = {
      Email: this.email,
    };

    this.coreService.emailReminder(body).then((reminderResponse: any) => {
      formRef.submitted = false;
      localStorage.removeItem('inviterId');
      this.resetForm();
      this.gaService.emitEvent('reminder', 'Reminder Screen');
     // document.getElementById("openModalButton").click(); // close when success. popup modal from landing page
      const successMessage = this.translate.instant(reminderResponse.messageKey);
      this.toast.success(successMessage, '');
      this.emailSubmitted = true;
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, '');
      return;
    });
  }

  resetForm() {
    this.email = undefined;
  }

}
